export const SWAP_CONTRACT_ADDRESS =
  "0x0b9609021Fa0683D49a01B7CafC1242eCcfCC561";
